/* eslint-disable max-len */
export default {
    title: 'Contact',
    form: {
        title: 'Leave us a message',
        placeholder: {
            name: 'Name',
            surname: 'Surname',
            email: 'Your corporate email',
            phone: 'Phone number',
            message: 'Message',
            topic: 'Select topic'
        },
        label: {
            checkbox: 'The data are administered by Sagiton Sp.z o.o., have been provided voluntarily and will be processed by the administrator in accordance with the provisions of the Act of 29 August 1997r. about the protection of personal data (Journal of Laws of 2002, No. 101, item 926, as amended) for marketing purposes, sale of products and services Sagiton Sp.z o.o. I have been informed of the right of access to the content of their data, their correcting and the right to lodge objections to their processing at any time.',
            checkbox2: 'I agree to receive from Sagiton Sp.z o.o. commercial information by email.',
            button: 'Send',
            refresh: 'Refresh',
            showEmail: 'Show Email',
            mailToTitle: 'Contact Request',
            mailToDisclaimerText: 'In order to make sure your request won’t be considered as a SPAM/BOT traffic, please use the email below that contains unique token assigned for you'
        }
    },
    people: {
        title: 'Do not wait and e-mail us now',
        button: 'Chat with a consultant',
        labels: {
            mobile: 'mobile',
            mail: 'mail'
        },
        list: [{
            name: 'Grzegorz Makosa',
            occupation: 'Business Development Partner',
            phone: '+48 71 700 03 01',
            email: 'grzegorz.makosa@lemlock.com'
        }]
    },
    headquarter: {
        title: 'Headquarter',
        address: {
            company: 'Lemlock',
            note: 'The lemlock brand is owned by Sagiton sp. z o.o (LLC)',
            country: 'Poland'
        }
    },
    map: {
        placeId: 'ChIJj0OamfvBD0cR2pqv0Y9-3UQ',
        infowindow: {
            navigate_text: 'Driving directions',
            navigate_url: 'https://www.google.com/maps?ll=51.1124,16.985984&z=16&t=m&hl=pl&gl=PL&mapclient=embed&daddr=Lemlock+-+Testy+Penetracyjne+Fabryczna+19+53-609+Wroc%C5%82aw@51.1124002,16.9859843',
            review_text: 'Reviews',
            review_url: 'http://www.google.pl/search?q=Lemlock+-+Testy+Penetracyjne,+Fabryczna+19,+53-609+Wroc%C5%82aw&ludocid=4962261520595524314#lrd=0x470fc1fb999a438f:0x44dd7e8fd1af9ada,1',
            large_map_text: 'Show large map'
        }
    }
};



// WEBPACK FOOTER //
// ./src/i18n/en/contact.js